// removed by extract-text-webpack-plugin
module.exports = {"container":"_3e7nBo3psCjvGROruYA04x","content":"XDV8Lz0vWZK_9bKKjvZlc","title":"_2-qWMSvDShUb1bqvAlK-yg","tabsWrapper":"GM339S_jLEX19vXDUO7Rr","tabs":"j02nW3_QNWE-5If9BRLED"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthenticationContainer/AuthenticationContainer.scss
// module id = 1804
// module chunks = 0